/**
 * Instagram-Style E-commerce Story Viewer Engine
 * Mobile-First, Progressive Media Loading, RTL Native, Gesture Support
 */

(function () {
  'use strict';

  var storiesState = {
    stories: [],
    currentGroupIndex: 0,
    currentSlideIndex: 0,
    timer: null,
    progressRaf: null,
    slideStartTime: 0,
    slideDurationMs: 5000,
    isPaused: false,
    pausedRemainingMs: 0,
    seenMap: {},
  };

  // Load seen stories from localStorage
  try {
    var rawSeen = localStorage.getItem('stories_seen_v1');
    if (rawSeen) {
      storiesState.seenMap = JSON.parse(rawSeen);
    }
  } catch (e) {
    storiesState.seenMap = {};
  }

  function saveSeen(storyId) {
    storiesState.seenMap[storyId] = Date.now();
    try {
      localStorage.setItem('stories_seen_v1', JSON.stringify(storiesState.seenMap));
    } catch (e) {}
    var el = document.querySelector(`.story-bubble[data-story-id="${storyId}"]`);
    if (el) el.classList.add('seen');
  }

  // Analytics event dispatcher
  function sendEvent(eventType, groupId, slideId) {
    try {
      var storeCode = window.STOREFRONT_CODE || (window.location.hostname.includes('avashop10') ? 'avashop10' : 'mehgis');
      fetch('/api/stories/events/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_type: eventType,
          story_group_id: groupId,
          story_slide_id: slideId,
          store_code: storeCode,
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  // Fetch stories and render Tray
  function initStoriesTray() {
    var trayRoot = document.getElementById('stories-tray-root');
    var stripWrapper = document.getElementById('stories-strip-wrapper');
    if (!trayRoot) return;

    fetch('/api/stories/')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data.stories || !data.stories.length) {
          if (stripWrapper) stripWrapper.remove();
          trayRoot.remove();
          return;
        }

        storiesState.stories = data.stories;
        renderTrayHTML(trayRoot, data.stories);
        if (stripWrapper) stripWrapper.classList.remove('hidden');
        setupIntersectionImpression();
      })
      .catch(function () {
        if (stripWrapper) stripWrapper.remove();
        trayRoot.remove();
      });
  }

  function renderTrayHTML(root, stories) {
    var isAvashop = window.location.hostname.includes('avashop10');
    if (isAvashop) {
      root.classList.add('theme-avashop');
      var sec = document.getElementById('stories-tray-section');
      if (sec) sec.classList.add('theme-avashop');
    }

    var html = `
      <button type="button" class="story-nav-btn story-nav-prev" aria-label="استوری‌های قبلی">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7"/></svg>
      </button>
      <div class="story-tray-container" id="story-tray-scroll">
    `;

    stories.forEach(function (story) {
      var isSeen = storiesState.seenMap[story.id];
      html += `
        <div class="story-bubble ${isSeen ? 'seen' : ''}" data-story-id="${story.id}">
          <div class="story-ring">
            <div class="story-avatar-wrap">
              <img src="${story.cover_url || '/static/img/placeholder.png'}" alt="${story.title}" class="story-avatar" loading="lazy">
            </div>
            ${story.badge_text ? `<span class="story-badge">${story.badge_text}</span>` : ''}
          </div>
          <span class="story-title">${story.title}</span>
        </div>
      `;
    });

    html += `
      </div>
      <button type="button" class="story-nav-btn story-nav-next" aria-label="استوری‌های بعدی">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7"/></svg>
      </button>
    `;

    root.innerHTML = html;

    // Attach click listeners to bubbles
    root.querySelectorAll('.story-bubble').forEach(function (bubble, idx) {
      bubble.addEventListener('click', function () {
        openViewer(idx, 0);
      });
    });

    // Wire desktop chevron scroll buttons (RTL aware)
    var scrollContainer = document.getElementById('story-tray-scroll');
    var prevBtn = root.querySelector('.story-nav-prev');
    var nextBtn = root.querySelector('.story-nav-next');

    if (prevBtn && scrollContainer) {
      prevBtn.addEventListener('click', function () {
        scrollContainer.scrollBy({ left: 240, behavior: 'smooth' });
      });
    }
    if (nextBtn && scrollContainer) {
      nextBtn.addEventListener('click', function () {
        scrollContainer.scrollBy({ left: -240, behavior: 'smooth' });
      });
    }
  }

  function setupIntersectionImpression() {
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var id = entry.target.dataset.storyId;
          if (id) {
            sendEvent('story_impression', id, null);
            observer.unobserve(entry.target);
          }
        }
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('.story-bubble').forEach(function (el) {
      observer.observe(el);
    });
  }

  // Open Fullscreen Viewer
  function openViewer(groupIndex, slideIndex) {
    storiesState.currentGroupIndex = groupIndex;
    storiesState.currentSlideIndex = slideIndex || 0;

    var modal = document.getElementById('story-viewer-modal');
    if (!modal) return;

    modal.classList.add('open');
    document.body.style.overflow = 'hidden';

    var currentGroup = storiesState.stories[groupIndex];
    sendEvent('story_open', currentGroup.id, null);

    renderActiveSlide();
  }

  function closeViewer() {
    storiesState.isPaused = true;
    clearTimeout(storiesState.timer);
    cancelAnimationFrame(storiesState.progressRaf);
    storiesState.progressRaf = null;

    var modal = document.getElementById('story-viewer-modal');
    if (modal) modal.classList.remove('open');
    document.body.style.overflow = '';

    // Stop playing any videos
    var mediaContainer = document.getElementById('story-media-container');
    if (mediaContainer) {
      var vid = mediaContainer.querySelector('video');
      if (vid) {
        vid.pause();
        vid.src = '';
      }
    }
  }

  function renderActiveSlide() {
    clearTimeout(storiesState.timer);
    cancelAnimationFrame(storiesState.progressRaf);
    storiesState.isPaused = false;

    var group = storiesState.stories[storiesState.currentGroupIndex];
    if (!group || !group.slides || !group.slides.length) {
      closeViewer();
      return;
    }

    var slide = group.slides[storiesState.currentSlideIndex];
    sendEvent('slide_view', group.id, slide.id);

    // Update Header
    document.getElementById('story-viewer-title').textContent = group.title;
    document.getElementById('story-viewer-avatar').src = group.cover_url || '/static/img/placeholder.png';

    // Render Progress Bars
    var progressRoot = document.getElementById('story-progress-root');
    progressRoot.innerHTML = '';
    group.slides.forEach(function (s, idx) {
      var bar = document.createElement('div');
      bar.className = 'story-progress-bar' + (idx < storiesState.currentSlideIndex ? ' completed' : '');
      var fill = document.createElement('div');
      fill.className = 'story-progress-fill';
      bar.appendChild(fill);
      progressRoot.appendChild(bar);
    });

    // Render Media (Progressive & Lazy)
    var mediaRoot = document.getElementById('story-media-container');
    mediaRoot.innerHTML = '';

    var duration = (slide.duration || 5) * 1000;
    storiesState.slideDurationMs = duration;

    if (slide.media_type === 'video') {
      var video = document.createElement('video');
      video.src = slide.media_url;
      video.autoplay = true;
      video.playsInline = true;
      video.muted = false;
      video.className = 'w-full h-full object-cover';

      video.onloadedmetadata = function () {
        if (video.duration && !isNaN(video.duration)) {
          duration = video.duration * 1000;
          storiesState.slideDurationMs = duration;
        }
        startSlideTimer(duration);
      };

      video.onerror = function () {
        // Skip broken video gracefully
        nextSlide();
      };

      mediaRoot.appendChild(video);
    } else {
      var img = document.createElement('img');
      img.src = slide.media_url;
      img.alt = slide.title || group.title;
      img.className = 'w-full h-full object-cover';
      mediaRoot.appendChild(img);
      startSlideTimer(duration);
    }

    // Preload next slide media
    preloadNextSlide(group, storiesState.currentSlideIndex + 1);

    // Render CTA Bar
    renderCTA(slide, group.id);
  }

  function preloadNextSlide(group, nextIdx) {
    if (nextIdx < group.slides.length) {
      var nextSlide = group.slides[nextIdx];
      if (nextSlide.media_type === 'image') {
        var preImg = new Image();
        preImg.src = nextSlide.media_url;
      }
    }
  }

  function renderCTA(slide, groupId) {
    var ctaBar = document.getElementById('story-cta-bar');
    ctaBar.innerHTML = '';

    if (slide.cta_type === 'product' && slide.product_info) {
      var p = slide.product_info;
      var card = document.createElement('a');
      card.href = slide.cta_url || `/product/${p.id}/`;
      card.className = 'story-product-card';
      card.onclick = function () {
        sendEvent('cta_click', groupId, slide.id);
      };

      card.innerHTML = `
        <img src="${p.image_url || '/static/img/placeholder.png'}" alt="${p.title}">
        <div class="story-product-info">
          <div class="story-product-title">${p.title}</div>
          <div class="story-product-price">${Number(p.price).toLocaleString('fa-IR')} تومان</div>
        </div>
        <div class="story-cta-btn ${p.has_stock ? '' : 'unavailable'}">
          ${p.has_stock ? (slide.cta_text || 'مشاهده محصول') : 'ناموجود'}
        </div>
      `;
      ctaBar.appendChild(card);
    } else if (slide.cta_type !== 'none' && slide.cta_url) {
      var btn = document.createElement('a');
      btn.href = slide.cta_url;
      btn.className = 'story-generic-cta';
      btn.textContent = slide.cta_text || 'اطلاعات بیشتر';
      btn.onclick = function () {
        sendEvent('cta_click', groupId, slide.id);
      };
      ctaBar.appendChild(btn);
    }
  }

  function startSlideTimer(duration) {
    storiesState.slideStartTime = performance.now();
    var currentFill = document.querySelectorAll('.story-progress-fill')[storiesState.currentSlideIndex];

    function animateProgress(now) {
      var modal = document.getElementById('story-viewer-modal');
      if (!modal || !modal.classList.contains('open') || storiesState.isPaused) return;

      var elapsed = now - storiesState.slideStartTime;
      var pct = Math.min(100, (elapsed / duration) * 100);
      if (currentFill) currentFill.style.width = pct + '%';

      if (elapsed < duration) {
        storiesState.progressRaf = requestAnimationFrame(animateProgress);
      } else {
        nextSlide();
      }
    }

    storiesState.progressRaf = requestAnimationFrame(animateProgress);
  }

  function nextSlide() {
    cancelAnimationFrame(storiesState.progressRaf);
    storiesState.progressRaf = null;

    var modal = document.getElementById('story-viewer-modal');
    if (!modal || !modal.classList.contains('open')) return;

    var group = storiesState.stories && storiesState.stories[storiesState.currentGroupIndex];
    if (!group || !group.slides || !group.slides.length) {
      closeViewer();
      return;
    }

    if (storiesState.currentSlideIndex < group.slides.length - 1) {
      storiesState.currentSlideIndex++;
      renderActiveSlide();
    } else {
      // Completed current story group
      sendEvent('story_complete', group.id, null);
      saveSeen(group.id);

      if (storiesState.currentGroupIndex < storiesState.stories.length - 1) {
        storiesState.currentGroupIndex++;
        storiesState.currentSlideIndex = 0;
        renderActiveSlide();
      } else {
        closeViewer();
      }
    }
  }

  function prevSlide() {
    cancelAnimationFrame(storiesState.progressRaf);
    storiesState.progressRaf = null;

    var modal = document.getElementById('story-viewer-modal');
    if (!modal || !modal.classList.contains('open')) return;

    if (storiesState.currentSlideIndex > 0) {
      storiesState.currentSlideIndex--;
      renderActiveSlide();
    } else if (storiesState.currentGroupIndex > 0) {
      storiesState.currentGroupIndex--;
      var prevGroup = storiesState.stories && storiesState.stories[storiesState.currentGroupIndex];
      if (!prevGroup || !prevGroup.slides || !prevGroup.slides.length) {
        renderActiveSlide();
        return;
      }
      storiesState.currentSlideIndex = prevGroup.slides.length - 1;
      renderActiveSlide();
    } else {
      renderActiveSlide();
    }
  }

  function pauseStory() {
    if (storiesState.isPaused) return;
    storiesState.isPaused = true;
    cancelAnimationFrame(storiesState.progressRaf);

    var media = document.getElementById('story-media-container')?.querySelector('video');
    if (media) media.pause();
  }

  function resumeStory() {
    if (!storiesState.isPaused) return;
    storiesState.isPaused = false;

    var media = document.getElementById('story-media-container')?.querySelector('video');
    if (media) media.play().catch(function () {});

    var currentFill = document.querySelectorAll('.story-progress-fill')[storiesState.currentSlideIndex];
    var currentPct = parseFloat(currentFill?.style.width || '0');
    var remainingPct = 100 - currentPct;
    var remainingTime = (remainingPct / 100) * storiesState.slideDurationMs;

    storiesState.slideStartTime = performance.now() - ((currentPct / 100) * storiesState.slideDurationMs);
    startSlideTimer(storiesState.slideDurationMs);
  }

  // Wire event handlers when DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    initStoriesTray();

    var closeBtn = document.getElementById('story-close-btn');
    if (closeBtn) closeBtn.addEventListener('click', closeViewer);

    // Tap zones for next / prev
    var tapLeft = document.getElementById('story-tap-left');
    var tapRight = document.getElementById('story-tap-right');

    // In RTL: tapping left advances forward, tapping right goes backward
    if (tapLeft) {
      tapLeft.addEventListener('click', function (e) {
        e.stopPropagation();
        nextSlide();
      });
    }
    if (tapRight) {
      tapRight.addEventListener('click', function (e) {
        e.stopPropagation();
        prevSlide();
      });
    }

    // Long press to pause
    var card = document.getElementById('story-viewer-card');
    if (card) {
      card.addEventListener('pointerdown', function (e) {
        if (e.target.closest('#story-cta-bar') || e.target.closest('.story-close-btn')) return;
        pauseStory();
      });
      card.addEventListener('pointerup', resumeStory);
      card.addEventListener('pointercancel', resumeStory);
    }

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      var modal = document.getElementById('story-viewer-modal');
      if (!modal || !modal.classList.contains('open')) return;

      if (e.key === 'Escape') {
        closeViewer();
      } else if (e.key === 'ArrowLeft') {
        nextSlide();
      } else if (e.key === 'ArrowRight') {
        prevSlide();
      }
    });

    // Auto pause on tab blur
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pauseStory();
      } else {
        resumeStory();
      }
    });
  });

  window.openStoryViewer = openViewer;
  window.closeStoryViewer = closeViewer;
})();
